import { gql, useQuery } from "@apollo/client";

export const FISCAL_YEAR_QUERY = gql`
  query GetFiscalYears {
    fiscalYears {
      fiscalYearId
      year
      startDate
    }
  }
`;

export const useGetFiscalYears = () => {
  const { data, loading, error, refetch } = useQuery(FISCAL_YEAR_QUERY);

  return {
    fiscalYearData: data,
    fiscalYearLoading: loading,
    fiscalYearError: error,
    refetchFiscalYear: refetch,
  };
};
